import dayjs from 'dayjs';

import { APP_LOCAL_DATETIME_FORMAT, APP_LOCAL_DATETIME_FORMAT_Z } from 'app/config/constants';
import moment from 'moment';

export const convertDateTimeFromServer = date => (date ? dayjs(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeToServer = date => (date ? dayjs(date).toDate() : null);

export const displayDefaultDateTime = () => dayjs().startOf('day').format(APP_LOCAL_DATETIME_FORMAT);

export function getStartAndEndOfMonth() {
  const today = dayjs();

  const startDate = today.startOf('month').format('YYYY-MM-DD');
  const endDate = today.endOf('month').format('YYYY-MM-DD');

  return { startDate, endDate };
}

export function isLessThanAnHour(heureDebut, heureFin) {
  const startTime = moment(heureDebut, 'HH:mm');
  const endTime = moment(heureFin, 'HH:mm');
  const minutesDifference = endTime.diff(startTime, 'minutes');
  return minutesDifference < 60;
}
